import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  Stack,
  Divider,
} from "@mui/material";
import React from "react";

const dataFooter = [
  {
    title: "Productos",
    links: [
      { name: "Línea Hospitalaria", href: "/#Productos" },
      { name: "Línea Farmacéutica", href: "/#Productos" },
      { name: "Productos Médicos", href: "/#Productos" },
    ],
  },
  {
    title: "Contacto",
    links: [
      { name: "Teléfono: (0341) 399-9900", href: "tel:+543413999900" },
      {
        name: "Email: info@lab-sertex.com.ar",
        href: "mailto:Info@lab-sertex.com.ar",
      },
      {
        name: "Dirección: Calle 1910 Nº 4535, Rosario, Santa Fe",
        href: "https://goo.gl/maps/ZGLsg62PH1rMXbYSA",
      },
    ],
  },
];

const isExternal = (href) => href.startsWith("http");

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      role="contentinfo"
      bgcolor="primary.main"
      color="white"
      py={5}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5} alignItems="flex-start">
          {/* Logo */}
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box sx={{ width: { xs: "60%", sm: "70%" }, height: 150 }}>
              <img
                src="/assets/logos/logohorizontal.png"
                alt="Laboratorio Sertex"
                loading="lazy"
                style={{ objectFit: "contain", width: "100%", height: "100%" }}
              />
            </Box>
          </Grid>

          {/* Secciones */}
          {dataFooter.map((section) => (
            <Grid
              item
              xs={12}
              sm={4}
              key={section.title}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: ".04em",
                  pb: 1,
                }}
              >
                {section.title}
              </Typography>
              <Divider
                sx={{
                  width: "60%",
                  mb: 1,
                  borderColor: "rgba(255,255,255,0.25)",
                }}
              />
              <Stack spacing={0.5}>
                {section.links.map((link) => (
                  <Link
                    key={link.name}
                    href={link.href}
                    color="inherit"
                    underline="hover"
                    target={isExternal(link.href) ? "_blank" : undefined}
                    rel={isExternal(link.href) ? "noopener" : undefined}
                    sx={{
                      "&:hover": { opacity: 0.9 },
                      lineHeight: 1.6,
                    }}
                  >
                    {link.name}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.15)" }} />

        <Box sx={{ textAlign: "center" }}>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            © {year} Laboratorio Sertex. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
